import React, { useCallback, useContext, useEffect, useState } from 'react'
import {
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { Controller, useForm } from 'react-hook-form'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { YesNoRadioButton } from '../Core/Buttons/ControlledRadioButtons'
import { BackButton } from '../Core/Buttons/BackButton'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { UserApi } from '../../api/user.api'
import {
  SessionContextStore,
  SESSION_ACTIONS,
} from '../../context/SessionContext'
import { awaitWithLoading, isOver18 } from '../../services/utils'
import { ContactSupportOutlined, Label, Watch } from '@material-ui/icons'
import CodeIcon from '@material-ui/icons/Code'
import { convertToYesOrNo } from '../../services/utils'
import './PilotDetails.scss'
import { UserProfileContextStore } from '../../context/UserProfileContext'
import DataLayerService from '../../services/DataLayerService'
import { useLocation } from 'react-router'
import { SkywatchDialog } from '../PopUps/SkywatchDialog'
import { isMobile, BrowserView, MobileView } from 'react-device-detect'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { ReactComponent as ShieldSvg } from '../../assets/shield.svg'
import {
  BuyingInsuranceContextStore,
  OFFERS_ACTIONS,
} from '../../context/BuyingInsuranceContext'
import { Action } from '../../models/Action'
import { OptionalTag } from '../Core/OptionalTag'
import NewFillButton from '../Core/NewFillButton'
import coveragesApi from '../../api/coverages.api'
import { Autocomplete } from '@material-ui/lab'
import { useFormContext } from 'react-hook-form'
import { debounce } from '../../services/utils'
import { useHistory } from 'react-router-dom'
import { EMAIL_REGEX } from "../../Constants";
import { DatePicker } from '@material-ui/pickers'
import {
  FirebaseConfigKey,
  FirebaseService,
} from '../../services/FirebaseService'
const TRAINING = [
  { key: 'InstrumentRating', value: 'Instrument rating' },
  { key: 'AircraftSingleEngineLand', value: 'Aircraft single engine land' },
  { key: 'AircraftMultiEngineLand', value: 'Aircraft multi-engine land' },
  { key: 'AircraftSingleEngineSea', value: 'Aircraft single engine sea' },
  { key: 'Glider', value: 'Glider' },
  { key: 'CertifiedFlightInstructor', value: 'Certified flight instructor' },
  {
    key: 'MasterCertifiedFlightInstructor',
    value: 'Master certified flight instructor',
  },
]

export const PilotDetails = () => {
  const history = useHistory()
  const sessionContext = React.useContext(SessionContextStore)
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const [AccidentAllow, setAccidentAllow] = useState(false)
  const [violationAllow, setViolationAllow] = useState(false)
  const [pilot_certification, setPilotCertification] = React.useState(
    sessionContext.user.userInsuredPersons.length > 0
      ? sessionContext.user.userInsuredPersons[0].pilot_certification
      : ''
  )
  const [pilot_training, setPilotTraining] = React.useState(
    sessionContext.user.userInsuredPersons.length > 0
      ? sessionContext.user.userInsuredPersons[0].pilot_training
      : []
  )
  let insuranceLast60Days = null

  if (sessionContext.user.insuranceLast60Days) {
    insuranceLast60Days = convertToYesOrNo(
      sessionContext.user.insuranceLast60Days
    )
  }

  const [names, setNames] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  async function filter(value) {
    if (value === '') {
      setNames([])
      return
    }
    setIsLoading(true)
    const { data } = await UserApi.getPilotSchools(value)
    if (Array.isArray(data)) {
      setNames(data.map((obj) => obj))
    } else {
      setNames([...data])
    }
    setIsLoading(false)
  }

  const debounceHandler = useCallback(debounce(filter, 500), [])
  const [selectedDate, setSelectedDate] = useState(null)

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  const handleFiltering = (e, newval) => {
    debounceHandler(newval)
  }
  const {
    register,
    control,
    getValues,
    trigger,
    errors,
    watch,
    reset,
    setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      ...sessionContext.user.userInsuredPersons[0],
      pilot_training: [],
      pilot_school_name: null,
      has_recent_logged_flight_time: insuranceLast60Days,
      flight_school_email: null
    },
  })

  const removeAirlineTransportPilot = () => {
    if (
      pilot_certification === 'AirlineTransportPilot' &&
      pilot_training.some((rating) => rating === 'InstrumentRating')
    ) {
      setPilotTraining(
        pilot_training.filter((rating) => rating != 'InstrumentRating')
      )
    }
  }

  const cleanPilotTraning = () => {
    setPilotTraining([])
  }

  const savePilotDetails = async () => {
    let res = await awaitWithLoading(
      UserApi.savePilotDetails(getValues(), pilot_training)
    )
    if (res.ok) {
      await awaitWithLoading(sessionContext.loadUser())
      EventEmitterService.dispatch(EventKey.FLOW_PILOT_FINIISH)
    } else EventEmitterService.dispatch(EventKey.ShowError, res)
  }

  const save = async () => {
    let valid = await trigger()

    if (!valid) return

    setTimeout(() => {
      var errElm = document.getElementsByClassName('Mui-error')
      if (errElm && errElm.length > 0) {
        var elementPosition = errElm[0].getBoundingClientRect().top
        var offsetPosition = elementPosition - 30
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      }
    }, 300)
    await savePilotDetails()
  }

  React.useEffect(() => {
    if (!!sessionContext.user.declinations) {
      sessionContext.user.declinations.forEach((e) => {
        if (e.override_type === 'Allow') {
          if (e.property === 'HasViolations') {
            setViolationAllow(true)
          }
          if (e.property === 'HasAccidents') {
            setAccidentAllow(true)
          }
        }
      })
    }
  }, [sessionContext.user.declinations])

  React.useEffect(() => {
    if (
      sessionContext.user &&
      sessionContext.user.userInsuredPersons.length > 0
    ) {
      setNames([sessionContext.user.userInsuredPersons[0].pilot_school_name])
      reset({
        ...sessionContext.user.userInsuredPersons[0],
        pilot_school_name:
          sessionContext.user.userInsuredPersons[0].pilot_school_name,
      })
    }
  }, [sessionContext.user])

  React.useEffect(() => {
    DataLayerService.pushToDataLayer({ event: 'pilot-page-load' })
  }, [])

  React.useEffect(() => {
    DataLayerService.pushToDataLayer({ event: 'pilot-page-load' })
  }, [])
  return (
    <Container>
      <div className="text-title bold blue">Pilot Details</div>
      <Divider />
      <div className="text-small-title bold black margin-bottom-small">
        Certification
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Controller
            rules={{
              required: true,
              validate: (x) => !!x && x != 'default',
            }}
            control={control}
            defaultValue={'default'}
            name="pilot_certification"
            render={(
              { onChange, onBlur, value, name, ref },
              { invalid, isTouched, isDirty }
            ) => (
              <>
                <Select
                  error={!!errors.pilot_certification}
                  fullWidth
                  variant="outlined"
                  onChange={onChange}
                  value={value}>
                  <MenuItem disabled value={'default'}>
                    <span className="gray">Pilot certification</span>
                  </MenuItem>
                  {sessionContext.user.insuranceType !== 'CFI' && (
                    <MenuItem
                      onClick={() => {
                        setPilotCertification('Student')
                        cleanPilotTraning()
                      }}
                      value={'Student'}>
                      Student
                    </MenuItem>
                  )}
                  {sessionContext.user.insuranceType !== 'CFI' && (
                    <MenuItem
                      onClick={() => {
                        removeAirlineTransportPilot()
                        setPilotCertification('Recreational')
                      }}
                      value={'Recreational'}>
                      Recreational
                    </MenuItem>
                  )}
                  {sessionContext.user.insuranceType !== 'CFI' && (
                    <MenuItem
                      onClick={() => {
                        removeAirlineTransportPilot()
                        setPilotCertification('Sport')
                      }}
                      value={'Sport'}>
                      Sport
                    </MenuItem>
                  )}
                  {sessionContext.user.insuranceType !== 'CFI' && (
                    <MenuItem
                      onClick={() => {
                        removeAirlineTransportPilot()
                        setPilotCertification('Private')
                      }}
                      value={'Private'}>
                      Private
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => {
                      removeAirlineTransportPilot()
                      setPilotCertification('Commercial')
                    }}
                    value={'Commercial'}>
                    Commercial
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setPilotCertification('AirlineTransportPilot')
                      if (
                        !pilot_training.some(
                          (rating) => rating === 'InstrumentRating'
                        )
                      ) {
                        setPilotTraining([
                          ...pilot_training,
                          'InstrumentRating',
                        ])
                      }
                    }}
                    value={'AirlineTransportPilot'}>
                    Airline transport pilot
                  </MenuItem>
                </Select>
                {!!errors.pilot_certification && (
                  <div className="text-tiny margin-top-3 margin-left-6 red">
                    Required
                  </div>
                )}
              </>
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          {pilot_certification != 'Student' && (
            <Controller
              control={control}
              rules={{
                required: true,
                validate: (x) =>
                  !!x &&
                  (x.length > 0 || pilot_training.length > 0) &&
                  ((sessionContext.user.insuranceType === 'CFI' &&
                    pilot_training.some(
                      (value) =>
                        value === 'CertifiedFlightInstructor' ||
                        value === 'MasterCertifiedFlightInstructor'
                    )) ||
                    sessionContext.user.insuranceType !== 'CFI'),
              }}
              name="pilot_training"
              render={(
                { onChange, onBlur, value, name, ref },
                { invalid, isTouched, isDirty }
              ) => (
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Pilot rating
                  </InputLabel>
                  <Select
                    fullWidth
                    autoWidth
                    multiple
                    labelId="demo-simple-select-label"
                    variant="outlined"
                    value={pilot_training}
                    MenuProps={{ variant: 'menu' }}
                    onChange={onChange}
                    renderValue={(selected) => {
                      return !!selected
                        ? selected
                            .map(
                              (s) =>
                                TRAINING.find((tr) => tr.key == s.trim()).value
                            )
                            .join(', ')
                        : ''
                    }}>
                    <MenuItem disabled value={'None'}>
                      <span className="gray">Pilot rating</span>
                    </MenuItem>
                    {TRAINING.map((train) => (
                      <MenuItem
                        key={train.key}
                        value={train.key}
                        onClick={(value) => {
                          if (
                            pilot_training.some((value) => value === train.key)
                          ) {
                            setPilotTraining(
                              pilot_training.filter(
                                (rating) => rating != train.key
                              )
                            )
                          } else {
                            setPilotTraining([...pilot_training, train.key])
                          }
                        }}>
                        <Checkbox
                          color="primary"
                          checked={
                            pilot_training
                              .map((x) => x.trim())
                              .indexOf(train.key.trim()) > -1 ||
                            (pilot_certification === 'AirlineTransportPilot' &&
                              train.key === 'InstrumentRating' &&
                              pilot_training.some(
                                (value) => value === 'InstrumentRating'
                              ))
                          }
                        />
                        <ListItemText primary={train.value} />
                      </MenuItem>
                    ))}
                  </Select>
                  {pilot_training.length <= 0 && (
                    <div className="text-tiny margin-top-3 margin-left-6 red">
                      Required
                    </div>
                  )}
                  {pilot_training.length > 0 &&
                    sessionContext.user.insuranceType === 'CFI' &&
                    !pilot_training.some(
                      (value) =>
                        value === 'CertifiedFlightInstructor' ||
                        value === 'MasterCertifiedFlightInstructor'
                    ) && (
                      <div className="text-tiny margin-top-3 margin-left-6 red">
                        CFI policies require CFI certification{' '}
                      </div>
                    )}
                </FormControl>
              )}
            />
          )}
        </Grid>
      </Grid>
      <br />
      <MobileView>
        <div className="text-small-title black bold margin-bottom-small">
          Hours logged
        </div>
      </MobileView>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Controller
            control={control}
            rules={{
              required: sessionContext.user.singleEngineLand,
              validate: (y) =>
                (getValues('pilot_certification') === 'Student' && y <= 300) ||
                getValues('pilot_certification') != 'Student',
              min: Math.max(
                getValues('total_hours_multi_engine_logged') ?? 0,
                getValues('total_hours_floats_logged') ?? 0
              ),
            }}
            name="total_hours_logged"
            render={(
              { onChange, onBlur, value, name, ref },
              { invalid, isTouched, isDirty }
            ) => (
              <TextField
                fullWidth
                onWheel={(event) => event.target.blur()}
                value={value && Math.max(0, value)}
                onChange={onChange}
                variant="outlined"
                placeholder="Total hours fixed wing"
                label="Total hours fixed wing"
                type="number"
                helperText={
                  errors.total_hours_logged &&
                  (errors.total_hours_logged.type == 'min'
                    ? 'Cannot be less than partial hours'
                    : errors.total_hours_logged.type == 'required'
                      ? 'Required'
                      : 'Students are limited to 300 logged hours. For more information, contact our support team.')
                }
                error={!!errors.total_hours_logged}
              />
            )}
          />
        </Grid>
        {sessionContext.user.multiEngineLand && (
          <Grid item xs={12} md={4}>
            <Controller
              control={control}
              rules={{
                required: sessionContext.user.multiEngineLand,
                validate: (x) =>
                  x <= parseInt(getValues('total_hours_logged')) && x >= 0,
              }}
              name="total_hours_multi_engine_logged"
              render={(
                { onChange, onBlur, value, name, ref },
                { invalid, isTouched, isDirty }
              ) => (
                <TextField
                  fullWidth
                  onWheel={(event) => event.target.blur()}
                  value={value && Math.max(0, value)}
                  onChange={onChange}
                  variant="outlined"
                  placeholder="Total hours multi engine"
                  label="Total hours multi engine"
                  type="number"
                  helperText={
                    errors.total_hours_multi_engine_logged &&
                    (errors.total_hours_multi_engine_logged.type == 'validate'
                      ? 'Must be less than total hours and positive'
                      : 'Required')
                  }
                  error={!!errors.total_hours_multi_engine_logged}
                />
              )}
            />
          </Grid>
        )}
        {sessionContext.user.singleEngineSeaplane && (
          <Grid item xs={12} md={4}>
            <Controller
              control={control}
              rules={{
                required: sessionContext.user.singleEngineSeaplane,
                validate: (x) =>
                  x <= parseInt(getValues('total_hours_logged')) && x >= 0,
              }}
              name="total_hours_floats_logged"
              render={(
                { onChange, onBlur, value, name, ref },
                { invalid, isTouched, isDirty }
              ) => (
                <TextField
                  fullWidth
                  onWheel={(event) => event.target.blur()}
                  value={value && Math.max(0, value)}
                  onChange={onChange}
                  variant="outlined"
                  label="Total hours floats"
                  placeholder="Total hours floats"
                  type="number"
                  helperText={
                    errors.total_hours_floats_logged &&
                    (errors.total_hours_floats_logged.type == 'validate'
                      ? 'Must be less than total hours and positive'
                      : 'Required')
                  }
                  error={!!errors.total_hours_floats_logged}
                />
              )}
            />
          </Grid>
        )}
      </Grid>
      <MobileView>
        <Divider />
      </MobileView>
      <BrowserView>
        <br />
      </BrowserView>
      <br />
      <div className="text-tiny-title black margin-bottom-small">
        From what school or club do you normally rent aircraft?
      </div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Controller
            name="pilot_school_name"
            control={control}
            rules={{ required: true }}
            render={({ onChange, ...props }) => (
              <Autocomplete
                {...props}
                loading={isLoading}
                className="margin-top-8"
                onInputChange={(e, data) => {
                  if (!data) return
                  onChange(data)
                  handleFiltering(e, data)
                }}
                onChange={(e, data) => {
                  onChange(data)
                }}
                options={names}
                filterOptions={(x) => x}
                handleHomeEndKeys
                freeSolo
                fullwidth
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <>
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'none',
                      }}
                      label="Flight school name"
                      fullWidth={true}
                      helperText={!!errors.pilot_school_name && 'Required'}
                      type="text"
                      error={!!errors.pilot_school_name}
                      className="margin-top-8"
                      placeholder="Flight school name"
                      variant="outlined"
                    />
                    <div className="margin-bottom-basic margin-top-6">
                      <div className="gray" style={{ fontSize: '0.8rem' }}>
                        (If you can’t find it on the list , please type the
                        name.)
                      </div>
                    </div>
                  </>
                )}
              />
            )}
          />
        </Grid>
      </Grid>
      {getValues('pilot_school_name') && (
                        <><div className="text-tiny-title black margin-bottom-small">
                    Cc insurance certificates to flight school (Optional)
                </div><Grid item xs={12} md={4}>
                        <Controller
                            control={control}
                            name="flight_school_email"
                            render={(
                                { onChange, onBlur, value, name, ref },
                                { invalid, isTouched, isDirty }
                            ) => (
                                <TextField
                                    name="flight_school_email"
                                    label={'Add flight school email'}
                                    error={!!errors.flight_school_email}
                                    fullWidth
                                    variant="outlined"
                                    type="email"
                                    placeholder="Add flight school email"
                                    inputRef={register({
                                        required: false,
                                        pattern: {
                                            value: EMAIL_REGEX,
                                            message: 'Please enter a valid email address.',
                                        },
                                    })}
                                    helperText={!!errors.flight_school_email &&
                                        (errors.flight_school_email.type == 'required'
                                            ? 'Required'
                                            : 'Please enter a valid email address.')} />
                            )} />
                    </Grid></>
                    )}
      {!sessionContext.user.insuranceLast60Days && (
        <YesNoRadioButton
          label={
            'Does the pilot have logged flight time in a fixed wing aircraft in last 60 days?'
          }
          name="has_recent_logged_flight_time"
          defaultValue={sessionContext.user.insuranceLast60Days}
          explainForYes={false}
          register={register}
          control={control}
          errors={errors}
          watch={watch}
        />
      )}
      <YesNoRadioButton
        label={
          'Does the pilot have any medical waivers other than corrective lenses or color blindness?'
        }
        name="has_medical_waivers"
        explainForYes
        defaultValue={getValues['has_medical_waivers']}
        register={register}
        control={control}
        errors={errors}
        watch={watch}
      />
      <YesNoRadioButton
        label={
          'In the last 5 years, has the pilot had any aviation accidents, incidents or losses? '
        }
        name="has_recent_accidents"
        defaultValue={getValues['has_recent_accidents']}
        register={register}
        control={control}
        detailsForYes
        errors={errors}
        watch={watch}
      />
      <Grid item xs={12} md={8}>
        {watch('has_recent_accidents') == 'yes' && (
          <>
            <TextField
              style={{ display: true ? undefined : 'none' }}
              fullWidth
              inputRef={register({ required: true })}
              variant="outlined"
              className="margin-bottom-small margin-top-small"
              label="Please provide more details"
              multiline
              disabled={AccidentAllow}
              rows={2}
              name={'has_recent_accidents_details'}
              helperText={
                !!errors['has_recent_accidents_details'] && 'Required'
              }
              error={!!errors['has_recent_accidents_details']}
            />
            <FlexView>
              <Controller
                className="margin-bottom-small margin-top-small"
                style={{ display: true ? undefined : 'none' }}
                as={
                  <DatePicker
                    disableFuture
                    openTo="year"
                    views={['year', 'month']}
                    label={'Date'}
                    inputVariant="outlined"
                    helperText={
                      !!errors['has_recent_accidents_date'] && 'Required'
                    }
                    error={!!errors['has_recent_accidents_date']}
                  />
                }
                // onChange={(date) => {
                //     setValue('has_recent_accidents_date', new Date(date[0]))
                //     return new Date(date[0])
                // }}
                onChange={handleDateChange}
                rules={{
                  required: true,
                }}
                name="has_recent_accidents_date"
                value={watch('has_recent_accidents_date')}
                defaultValue={null}
                disabled={AccidentAllow}
                control={control}
                fullWidth
              />
              <TextField
                style={{ display: true ? undefined : 'none' }}
                fullWidth
                disabled={AccidentAllow}
                variant="outlined"
                className="margin-left-basic margin-bottom-small margin-top-small"
                label="Value"
                inputRef={register({
                  validate: (x) => x >= 0 || x.trim() === '' || x === undefined,
                })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <OptionalTag />{' '}
                    </InputAdornment>
                  ),
                }}
                name={'has_recent_accidents_value'}
                helperText={
                  !!errors['has_recent_accidents_value'] && 'Required'
                }
                error={!!errors['has_recent_accidents_value']}
              />
            </FlexView>
          </>
        )}
      </Grid>

      <YesNoRadioButton
        label={
          <div>
            In the last 5 years, has the pilot:
            <ul>
              <li> been cited for violation of any aviation regulation or</li>
              <li> had their pilot’s or driver’s license suspended or</li>
              <li> been convicted of driving while intoxicated, or</li>
              <li> been convicted of any felony charges?</li>
            </ul>
          </div>
        }
        name="has_recent_violations"
        defaultValue={getValues['has_recent_violations']}
        register={register}
        disabled={violationAllow}
        control={control}
        explainForYes
        errors={errors}
        watch={watch}
      />

      <br />

      <FlexView vAlignContent={'center'}>
        <div className="margin-right-6">
          <BackButton />
        </div>
        <ContinueButton onClick={save} />
      </FlexView>
    </Container>
  )
}
